import { create } from 'zustand';

interface ProductDetailState {
  selectedProductId: string | null;
  isOpen: boolean;
  openProduct: (productId: string) => void;
  closeProduct: () => void;
}

export const useProductDetailStore = create<ProductDetailState>((set) => ({
  selectedProductId: null,
  isOpen: false,

  openProduct: (productId) =>
    set({
      selectedProductId: productId,
      isOpen: true,
    }),

  closeProduct: () =>
    set({
      selectedProductId: null,
      isOpen: false,
    }),
}));
